import {
  ReactElement,
  ReactNode,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { ThemeType } from '@sc/graphql';

export interface ChatTheme {
  brandColour: string;
  themeType: ThemeType;
  logoSrc: string;
  title?: string | null;
  subtitle?: string | null;
  projectName?: string | null;
}

interface ThemeContextValue {
  theme: ChatTheme | null;
  inverted: boolean;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: null,
  inverted: false,
});

export const ThemeProvider = ({
  theme,
  children,
}: {
  theme: ChatTheme | null | undefined;
  children: ReactNode;
}): ReactElement => {
  const value = useMemo<ThemeContextValue>(
    () => ({
      theme: theme ?? null,
      inverted: theme?.themeType === ThemeType.light,
    }),
    [theme]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => useContext(ThemeContext);
